import { call, put, takeEvery } from 'redux-saga/effects';
import { salesRepActionCreators, salesRepActionKeys, SaveSalesRep } from '..';
import { IEntityWithMessages } from '../../../services/HttpService';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { processMessages, showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import { saveSalesRep } from '../salesRepApi';
import { ISalesRep } from '../salesRepInterfaces';

function* saveSalesRepSaga(action: SaveSalesRep) {
  yield put(uiActionCreators.showSpinnerDialog());

  const response: IApiExecuteRespone<IEntityWithMessages<ISalesRep>> = yield call(saveSalesRep, action.payload);

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else if (response.value) {
    yield processMessages(response.value);

    if (response.value.value) {
      yield put(salesRepActionCreators.setSalesReps([response.value.value]));
    }
  }

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchSaveSalesRep() {
  yield takeEvery(salesRepActionKeys.SAVE_SALES_REP, saveSalesRepSaga);
}
